//

export var NO_SORT = 'none';
export var ASCENDING = 'ascending';
export var DESCENDING = 'descending';